import { cn } from "@/lib/utils";

export function ChevronDownIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("aspect-video h-auto w-4 text-white", className)}
      viewBox="0 0 16 9"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.933.39L7.63 5.564 2.327.39A1.385 1.385 0 00.4.39a1.305 1.305 0 000 1.88l6.273 6.12c.533.52 1.394.52 1.927 0l6.274-6.12c.533-.52.533-1.36 0-1.88-.534-.507-1.408-.52-1.941 0z"
        fill="currentColor"
      />
    </svg>
  );
}

export function ChevronRightIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("aspect-4/8 h-auto w-1 text-white", className)}
      viewBox="0 0 4 8"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M.178 1.226l2.357 2.778L.178 6.78a.806.806 0 000 1.01c.237.279.62.279.856 0l2.788-3.286a.806.806 0 000-1.01L1.034.21a.543.543 0 00-.856 0c-.231.28-.237.738 0 1.017z"
        fill="currentColor"
      />
    </svg>
  );
}
